import React from 'react';
import { Typography } from '@mui/material';
import cx from 'classnames';
import styles from './styles';

interface Props {
  libelle: string;
  isVisible?: boolean;
  variant: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

/**
 * Composant affichant les titres.
 */
const Titre: React.FC<Props> = ({ libelle, variant, isVisible = true }) => {
  return (
    <Typography
      sx={styles}
      variant={variant}
      component={variant}
      className={cx({ 'acc-hidden-title': !isVisible })}
      dangerouslySetInnerHTML={{ __html: libelle }}
    />
  );
};

export default Titre;
